import { Globals } from "../CoreApp/Globals";
import { getsessioncounter } from "./getsessioncounter";

export function getsessioninfojson(jsonData) {
  Globals._sessionCounter++;
  jsonData["sk"] = Globals._sessionKey;
  jsonData["zc"] = getsessioncounter();
}
